import { type App, createApp, defineAsyncComponent } from "vue";
import { httpClient } from "@allwyn/utils/http-clients/http-client";

interface GameHelpPageResponseModel {
    title: string;
    text: string;
}

const helpCache = new Map<number, GameHelpPageResponseModel>();
let activeApp: App | null = null;

export async function showGameHelpPopup(gameId: number) {
    if (activeApp) {
        return;
    }

    let helpData = helpCache.get(gameId);

    if (!helpData) {
        const response = await httpClient.get<GameHelpPageResponseModel>(`/api/casino/help-page/${gameId}`);
        helpData = response.data;
        helpCache.set(gameId, helpData);
    }

    const gameHelpPopup = defineAsyncComponent(() => import("./game-help/game-help-popup.vue"));

    const wrapper = document.createElement("div");
    document.body.appendChild(wrapper);

    activeApp = createApp(gameHelpPopup, {
        title: helpData.title,
        text: helpData.text,
        onUnmounted: () => {
            activeApp?.unmount();
            activeApp = null;
            wrapper.remove();
        },
    });

    activeApp.mount(wrapper);
}
